import alerts from './modules/alerts'
import appointments from './modules/appointments'
import auth from './modules/auth'
import chat from './modules/chat'
import devices from './modules/devices'
import files from './modules/files'
import geofencing from './modules/geofencing'
import groups from './modules/groups'
import healthreports from './modules/healthreports'
import help from './modules/help'
import invitations from './modules/invitations'
import medicaldocuments from './modules/medicaldocuments'
import notifications from './modules/notifications'
import organizations from './modules/organizations'
import parameters from './modules/parameters'
import patients from './modules/patients'
import pillbox2 from './modules/pillbox2'
import pillboxes from './modules/pillboxes'
import plan from './modules/plan'
import profile from './modules/profile'
import readings from './modules/readings'
import staff from './modules/staff'
import statics from './modules/statics'
import subscriptions from './modules/subscriptions'
import users from './modules/users'
import warnings from './modules/warnings'
import watches from './modules/watches'
import permissions from './modules/permissions'

const api = {
	alerts,
	appointments,
	auth,
	chat,
	devices,
	files,
	geofencing,
	groups,
	healthreports,
	help,
	invitations,
	medicaldocuments,
	notifications,
	organizations,
	parameters,
	patients,
	pillbox2,
	pillboxes,
	plan,
	profile,
	readings,
	staff,
	statics,
	subscriptions,
	users,
	warnings,
	watches,
	permissions
}

export default function install(Vue, options) {
	Object.defineProperties(Vue.prototype, {
		$api: {
			get: function () {
				return api
			}
		}
	})
	Vue.api = api
}



// WEBPACK FOOTER //
// ./src/api/index.js